import * as React from 'react'
import cx from 'classnames'

import Styles from './InfoTooltip.module.scss'
import { Popover } from 'antd'

interface Props {
  label?: string
  description: string | React.ReactNode
  icon?: React.ReactNode
  children: React.ReactNode
  placement: Popover['props']['placement']
  className?: string
  trigger?: Popover['props']['trigger']
}

export const InfoTooltip = ({ label, description, icon, children, placement, className, trigger = 'hover' }: Props) => {
  const content = (
    <div className={cx(Styles.tooltipContent, className)}>
      {icon && <div>{icon}</div>}
      <div>
        {label && <div className={Styles.tooltipHeader}>{label}</div>}
        <div>{description}</div>
      </div>
    </div>
  )

  return (
    <Popover placement={placement} content={content} overlayClassName={Styles.antdOverride} trigger={trigger}>
      {children}
    </Popover>
  )
}
